
import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import reservation 	from './reservation';

const state = {
	translations: {},
	salutations: [],
	cs_translations: {},
	params: [],

	stations: [],
	groups: [],
	offers: [],
	config: [],
};

export default {
	namespaced: true,
    state,
    mutations,
    actions,
    getters,
    modules: {
    	reservation,
    },
};



// WEBPACK FOOTER //
// ./src/store/orm/index.js